import classNames from 'classnames';
import { action, observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { X7PushableBlockSnapshot, X8BlockSnapshot, X8BlockType } from '../../../domain';
import { X9StudentComponent } from '../../content/x9/X9StudentComponent';
import { ExamStudentSceneStore } from './ExamStudentSceneStore';

function blockHeaderClassName(blockType: X8BlockType) {
  switch (blockType) {
    case 'Visible':
      return 'card-header alert-primary';
    case 'Pushable':
      return 'card-header alert-success';
    case 'Hidden':
      return 'card-header alert-warning';
    default:
      return 'card-header';
  }
}

@observer
class RenderBlockSnapshot extends React.Component<{
  store: ExamStudentSceneStore,
  blockSnapshot: X8BlockSnapshot
}> {

  render() {
    const store = this.props.store;
    const block = this.props.blockSnapshot;

    return (
      <div className="card">
        <div className={blockHeaderClassName(block.BlockType)}>
          <div className="row">
            <div className="col"> Block</div>
          </div>
        </div>
        
        <div className="card-body">
          {block.ContentSnapshots?.length === 0 && 
            <div className="row justify-content-center">
              <div className="col-auto">
                <div className="alert alert-info">empty block</div>
              </div>
            </div>
          }

          {block.ContentSnapshots?.map((content) =>
            <X9StudentComponent key={content.Id}
              x9={content}
              store={store.hubStore.examKeyValues} />
          )}
        </div>
      </div>
    );
  }
}



@observer
class RenderBlockSnapshots extends React.Component<{
  store: ExamStudentSceneStore,
  blocks: readonly X8BlockSnapshot[]
}> {
  render() {
    const store = this.props.store;
    
    const blocks = this.props.blocks ?? [];

    if (blocks === null || blocks.length === 0)
      return (
        <div className="row justify-content-center">
          <div className="col-auto">
            <div className="alert alert-info">empty pushable block</div>
          </div>
        </div>);

    return blocks.filter(x => x.BlockType ==='Visible').map((block) =>
      <RenderBlockSnapshot key={block.Id}
        store={store}
        blockSnapshot={block} />
    );
  }
}

@observer
class RenderPushableBlockSnapshot extends React.Component<{
  store: ExamStudentSceneStore,
  pushableBlockSnapshot: X7PushableBlockSnapshot
}> {

  render() {
    const pb = this.props.pushableBlockSnapshot;
    const store = this.props.store;
    return (
      <div className="card">
        <div className="card-header">
          <div>Pushable Block: {pb.Name}</div>
        </div>

        <div className="card-body">
          <RenderBlockSnapshots store={store}
            blocks={pb.BlockSnapshots!} />
        </div>
      </div>);
  }
}

@observer
class RenderPushableBlockSnapshots extends React.Component<{
  store: ExamStudentSceneStore,
  pushableBlockSnapshots: readonly X7PushableBlockSnapshot[]
}> {
  render() {
    const store = this.props.store;
    const snapshots = this.props.pushableBlockSnapshots;
    if (snapshots === null || snapshots.length === 0)
      return (
        <div className="row justify-content-center">
          <div className="col-auto">
            <div className="alert alert-info">empty page</div>
          </div>
        </div>);

    return snapshots.map((pb) =>
      <RenderPushableBlockSnapshot key={pb.Id}
        store={store}
        pushableBlockSnapshot={pb} />);
  }
}

@observer
export class StudentExamTabs extends React.Component<{ store: ExamStudentSceneStore }> {
  @observable
  activeTab: number = 0;

  @action
  setActiveTab = (activeTab: number) => {
    this.activeTab = activeTab;
    this.props.store.hubStore.examKeyValues.setActiveTab(activeTab);
  };

  constructor(props: { store: ExamStudentSceneStore }) {
    super(props);
    makeObservable(this);
  }

  componentDidMount() {
    this.activeTab = this.props.store.hubStore.examKeyValues.activeTabIndex;;
  }

  render() {
    const store = this.props.store;
    const snapshot = store.snapshot!;
 
    if (snapshot === null)
      return null;

    let activeTab = this.activeTab;
    var x6Snapshots = snapshot.PageSnapshots ?? [];


    if (x6Snapshots.length === 0)
      return (
        <div className="row">
          <div className="col">
            <div className="alert alert-info">Lesson is empty</div>
          </div>
        </div>);



    return (
      <div className="row">
        <div className="col">
          <Nav tabs>
            {x6Snapshots.map(
              (page, index) =>
                <NavItem key={index}>
                  <NavLink className={classNames({ active: activeTab === index })}
                    onClick={() => this.setActiveTab(index)}>
                    {page.Name}
                  </NavLink>
                </NavItem>
            )
            }
          </Nav>
          <TabContent activeTab={activeTab}>
            {x6Snapshots.map(
              (page, index) =>
                <TabPane tabId={index} key={index}>
                  <RenderPushableBlockSnapshots
                    store={store}
                    pushableBlockSnapshots={page.PushableBlockSnapshots!} />
                </TabPane>
            )}
          </TabContent>
        </div>
      </div>
    );
  }
}
